// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".stream-video-module__streamWrapper--24Yju{padding:10px;border:1px solid #393a40;border-radius:6px;background-color:#1a1b20}@media screen and (min-width:1152px){.stream-video-module__streamWrapper--24Yju{padding:20px}}", ""]);
// Exports
exports.locals = {
	"streamWrapper": "stream-video-module__streamWrapper--24Yju"
};
module.exports = exports;
